import { Injectable, Injector } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { tap } from "rxjs/operators";
import { WEBGL2, GLTF } from "./webgl2-token";
import { PBR_SHADER } from "../shaders/shader-program.module";
import { InputManager } from "../game-engine/input-manager";
import { MaterialLoader } from "../materials/material-loader";
import { BufferLoader } from "../webgl2/buffer-loader";
import { SceneRenderer } from "../renderers/scene-renderer";
import { shader_providers } from "../shaders/shader-program.module";
var GLTFLoader = (function () {
    function GLTFLoader(http_client_, parent_injector_) {
        this.http_client_ = http_client_;
        this.parent_injector_ = parent_injector_;
    }
    GLTFLoader.prototype.getItem = function (type) {
        return this.injector_.get(type);
    };
    ;
    ;
    GLTFLoader.prototype.createWebGLResources = function (context) {
        this.webgl_context_ = context;
        var providers = [
            { provide: WEBGL2, useValue: this.webgl_context_ },
            { provide: GLTF, useValue: this.gltf_data_ },
            { provide: MaterialLoader, useClass: MaterialLoader, deps: [HttpClient, WEBGL2, GLTF] },
            { provide: BufferLoader, useClass: BufferLoader, deps: [HttpClient, GLTF] },
            {
                provide: SceneRenderer,
                useClass: SceneRenderer,
                deps: [WEBGL2, GLTF, InputManager, PBR_SHADER, MaterialLoader, BufferLoader]
            }
        ].concat(shader_providers);
        this.injector_ = Injector.create(providers, this.parent_injector_);
    };
    ;
    GLTFLoader.prototype.fetchGLTFData = function (uri, context) {
        var _this = this;
        return this.http_client_.get(uri)
            .pipe(tap(function (data) {
            _this.gltf_data_ = data;
            _this.createWebGLResources(context);
        }));
    };
    ;
    GLTFLoader.decorators = [
        { type: Injectable },
    ];
    GLTFLoader.ctorParameters = function () { return [
        { type: HttpClient, },
        { type: Injector, },
    ]; };
    return GLTFLoader;
}());
export { GLTFLoader };
//# sourceMappingURL=scene-loader.js.map